"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccessibleForeground = void 0;
var _color = require("@cbhq/d3/color");
var _colorToSpectrumAlias = require("./colorToSpectrumAlias");
var _getContrastRatio = require("./getContrastRatio");
var _isAccessibleColor = require("./isAccessibleColor");
var _isGray = require("./isGray");
/**
 * People with low vision often have difficulty reading text that does not contrast with its background.
 * This can be exacerbated if the person has a color vision deficiency that lowers the contrast even further.
 * Providing a minimum luminance contrast ratio between the text and its background can make the text more
 * readable even if the person does not see the full range of colors. It also works for the rare individuals who see no color.
 *
 * 1. Check if foreground color meets contrast criteria.
 * 2. If pass, return color passed in.
 * 3. If fail, check saturation.
 * 4. If gray color check if white or black have a higher contrast ratio. Return the value with the highest contrast ratio.
 * 5. If non gray color return check if closest CDS spectrum alias (i.e. `orange60`) has a higher contrast ratio than passed in values.
 */
const getAccessibleForeground = (background, foreground, usage, transformFn, enhanced) => {
  if (foreground === 'auto') {
    return (0, _isAccessibleColor.isAccessibleColor)({
      background,
      foreground: 'white',
      usage
    }) ? 'rgb(255,255,255)' : 'rgb(0,0,0)';
  }
  const isAccessibleForeground = (0, _isAccessibleColor.isAccessibleColor)({
    background,
    foreground,
    usage,
    enhanced
  });
  if (isAccessibleForeground) {
    return foreground;
  }
  const spectrumAlias = (0, _colorToSpectrumAlias.colorToSpectrumAlias)(foreground, usage, enhanced);
  const darkestGrayContrastRatio = (0, _getContrastRatio.getContrastRatio)(background, 'rgb(0,0,0)');
  const lightestGrayContrastRatio = (0, _getContrastRatio.getContrastRatio)(background, 'rgb(255,255,255)');

  // If gray foreground doesn't meet a11y, check if darkest or lightest gray have a higher ratio
  if ((0, _isGray.isGray)((0, _color.hsl)(foreground))) {
    return darkestGrayContrastRatio > lightestGrayContrastRatio ? 'rgb(0,0,0)' : 'rgb(255,255,255)';
  }
  return transformFn(spectrumAlias);
};
exports.getAccessibleForeground = getAccessibleForeground;